var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconAnimation = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M8.4,17c1.6-.8,3.5-.6,4.8.6,2,2,3.2,7.2,3.2,7.2,0,0,.5-4,.8-6.6s.7-3.6,1.4-5.3c1.2-2.8,5.6-6.2,8.1-5.4" }),
            React.createElement("path", { strokeWidth: 2, d: "M5.4,19.4h0" }),
            React.createElement("path", { strokeWidth: 2, d: "M2.4,24.3h0" }),
            React.createElement("path", { strokeWidth: 5, d: "M26.6,7.2h0" }))));
});
export default IconAnimation;
//# sourceMappingURL=IconAnimation.js.map